import axios from 'axios';
import jwt_decode from "jwt-decode";
import { API_BASE_URL } from '../../config';
import { forceLogout } from '.';
import { GetLocStorage, SetLocStorage } from '../../utils';

const expirationMargin = 5 * 60 * 1000
let refreshingTokenNow = false

export const RefreshToken = async () => {

    const userToken = GetLocStorage("ut")
    const refreshToken = GetLocStorage("rt")

    let now = new Date()
    now.setTime(now.getTime() - expirationMargin)

    while (refreshingTokenNow)
        await new Promise(resolve => setTimeout(resolve, 1000));

    let token = null
    if (userToken)
        token = jwt_decode(userToken)

    if (token && new Date(token.exp * 1000) < now) {
        refreshingTokenNow = true

        await axios.post(`${API_BASE_URL}auth/refresh`, {
            accessToken: userToken,
            refreshToken: refreshToken
        }).then(result => {
            SetLocStorage('ut', result.data.data.accessToken)
            SetLocStorage('rt', result.data.data.refreshToken)

        }).catch(error => {
            if (error.response?.status === 403 || error.response?.status === 500) return forceLogout()
        })

        refreshingTokenNow = false
    }

}